import { defineComponent as _defineComponent } from 'vue'
import { isNil } from '@/utils/misc';
import ActionBubble, { BubbleType } from '../ActionBubble.vue';
import { inject } from 'vue';
import { TranslateResult } from 'vue-i18n';


/** @deprecated THIS COMPONENT IS FROZEN **/
const __default__ = {};

export default /*#__PURE__*/_defineComponent({
  ...__default__,
  __name: 'TableActionButton2',
  props: {
    icon: null,
    title: null,
    iconPack: { default: 'mdi' },
    disabled: { type: Boolean, default: false },
    hidden: { type: Boolean, default: false },
    bubble: null,
    bubbleType: { default: 'is-info' }
  },
  emits: ['click'],
  setup(__props: any, { emit }) {





const shouldUseMenu = inject<boolean>('shouldUseMenu', false);

return { __sfc: true,emit, shouldUseMenu, isNil, ActionBubble }
}

})